module.exports = __webpack_public_path__ + "img/discover.2416e9bf.svg";